module.exports = __webpack_public_path__ + "img/logo.57380db3.svg";